module.exports = __webpack_public_path__ + "img/Noctiluca-1-mobile.e8cc8c94.png";